/* eslint-disable max-len */
import { createElFromString } from './createElFromString';

export const createButtonHtml = ({
    text, color = 'white', size = 'size-1', classes = '', attributes = {}
}) => {
    const attributesString = Object.entries(attributes).reduce((accumulator, [key, value]) => `${accumulator} ${key}=${value}`, '');

    return `
        <button class="button button--${color} button--${size} ${classes}" ${attributesString}>
            <span class="button__text">${text}</span>
            <span class="button__bg"></span>
        </button>
    `;
};

export const createButtonEl = (...args) => {
    const html = createButtonHtml(...args);

    return createElFromString(html);
};
